import { Request } from "../request";

let num =1;

//获取用户信息
export function getUserInfo(params) {
    return Request.http.post("/admin/user/getUserInfo", params, num);
}

//登录
export function login(params) {
    return Request.http.post("/admin/user/login", params, num);
}

//微信  qq 登录  
export function redirect(params) {
    return Request.http.post("/admin/third/redirect", params, num);
}

//注册 手机号注册
export function phoneRegister(params) {
    return Request.http.post("/admin/user/phoneRegister", params, num);
}

//发送验证码接口
export function sendmsg(params) {
    return Request.http.post("/admin/user/sendmsg", params, num);
}

//验证手机号是否正确
export function checkIsLegalValidCode(params) {
    return Request.http.post("/admin/user/checkIsLegalValidCode", params, num);
}

//修改用户信息
export function loginEditMsg(params) {
    return Request.http.post("/admin/user/editMsg", params, num);
}


//文章收藏   取消收藏 
export function followArticle(params) {
    return Request.http.post("/admin/article/followArticle.html", params, num);
}

//我的收藏
export function followList(params) {
    return Request.http.post("/admin/user/followList", params, num);
}

//banner 广告
export function bannerList(params) {
    return Request.http.post("/admin/banner/list", params, num);
}

//信息收集接口
export function homePageCollectMsg(params) {
    return Request.http.post("/admin/other/homePageCollectMsg.html", params, num);
}










// WEBPACK FOOTER //
// ./src/api/lxc/index.js